export default __webpack_public_path__ + "static/gasper-f127aee176f9d645677d6c3bc4fe19d1.png";